import React from 'react';

import PlainHeader from '../../components/plain-header';

export default class Tabs extends React.Component {
  onChangeTab = pane => () => {
    this.props.onClick(pane);
  };

  render() {
    const {
      data,
      hideTabs,
      active,
      title,
      tabsStyle,
      headerStyle,
      onClick,
      panesTitles,
    } = this.props;

    return (
      <div className={`${headerStyle}`}>
        { title && <PlainHeader title={title} /> }
        <div className={tabsStyle}>
          { !hideTabs &&
            <ul className="panes">
              { data.map(pane => {
                const formattedPane = pane.charAt(0).toUpperCase() + pane.slice(1).toLowerCase();
                return (
                  <li key={pane} className={active === pane ? 'active' : ''}>
                    <p onClick={onClick(pane)}>
                      { panesTitles ? panesTitles[pane].toLowerCase() : formattedPane }
                    </p>
                  </li>
                );
              })}
              <li className="spacer" />
            </ul>
          }
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  onClick: React.PropTypes.func,
};



/** WEBPACK FOOTER **
 ** ./src/components/tabs/index.js
 **/